import type { ReactNode } from "react";

type SectionTagProps = {
  children: ReactNode;
  tone?: "primary" | "accent" | "secondary" | "light";
  className?: string;
};

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
  light: "bg-background-50/10 text-background-50 border-background-50/25",
};

export default function SectionTag({ children, tone = "primary", className = "" }: SectionTagProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium tracking-[0.16em] ${toneMap[tone]} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {children}
    </span>
  );
}